(function () {
    'use strict';

    angular
        .module('auditMandateModule')
        .controller('AuditMandateObservationsListController', Controller);

    Controller.$inject = ['$scope', 'topBarService', 'historyCtxtService', 'auditMandate'];

    function Controller($scope, topBarService, historyCtxtService, auditMandate) {

        topBarService.setTitleAndIcon('Audit Mandates', 'fa fa-road');
        $scope.auditMandate = auditMandate;

        // Edit Observation
        $scope.editObservation = function (item) {
            historyCtxtService.goToState('observation.edit',
                { ObservationID: item.ObservationID },
                'auditMandate'
            );
        };
        $scope.addObservation = function () {
            historyCtxtService.goToState('observation.addForAuditMandate',
                { AuditMandateID: auditMandate.GovernanceProcessID },
                'auditMandate'
            );
        };

    }
})();